import React from "react";
import Hero from "./Hero";
import About from "./About/About";
import Partner from "./Partner/Partner";
import Teams from "./Teams/Teams";
import NewsBlogs from "./NewsBlogs";
import Contact from "./Contact/Contact";
import Ecosystem from "./ECOSYSTEM/Ecosystem";
import Footer from "../layouts/Footer";


const Landing = () => {
  return (
    <div>
 
      <Hero />
      <About/>
      <Ecosystem/>
      <Partner/>
      <Teams/>
      <NewsBlogs/>
      <Contact/>
      <Footer/>
    </div>
  );
};

export default Landing;
